import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingService {
    private activeLoading = false;
    private isLoadingDataSubject = new BehaviorSubject<boolean>(false);

    readonly loading = this.isLoadingDataSubject.asObservable();

    setLoading(loading: boolean): void {
        this.activeLoading = loading;
        this.nextLoading();
    }

    nextLoading(): void {
        this.isLoadingDataSubject.next(this.activeLoading);
    }
}
